import React, { useState } from 'react';
import Navbar from '../../components/navbar/navbar';
import Footer from '../../components/footer/index';
import { useDarkMode } from '../../components/darkmode/DarkModeContext'; // Import the context
import Diskon from '../../components/layanan/tower_triagle.jsx/paket'
import { Triangle, Wifi, MapPin, CheckCircle, Users, Shield, MessageCircle, ArrowRight } from 'lucide-react';

const TowerTrianglePage = () => {
  // Remove local dark mode state and use context instead
  const { isDarkMode } = useDarkMode();
  const towerFeatures = [
    {
      icon: <Triangle className="w-8 h-8" />,
      title: "Desain Segitiga Kokoh",
      description: "Struktur segitiga memberikan stabilitas dan kekuatan maksimal untuk menara",
      color: "bg-blue-500"
    },
    {
      icon: <Shield className="w-8 h-8" />,
      title: "Material Berkualitas Tinggi",
      description: "Dibuat dari material galvanis anti karat untuk ketahanan cuaca ekstrem",
      color: "bg-green-500"
    },
    {
      icon: <Wifi className="w-8 h-8" />,
      title: "Kompatibilitas Perangkat",
      description: "Mendukung berbagai perangkat komunikasi dan pengawasan",
      color: "bg-purple-500"
    },
    {
      icon: <Users className="w-8 h-8" />,
      title: "Instalasi Profesional",
      description: "Tim ahli berpengalaman dalam pemasangan tower yang aman dan tepat",
      color: "bg-yellow-500"
    },
    {
      icon: <MapPin className="w-8 h-8" />,
      title: "Survey Lokasi",
      description: "Analisis lokasi untuk penempatan optimal dan efektivitas maksimal",
      color: "bg-red-500"
    },
    {
      icon: <CheckCircle className="w-8 h-8" />,
      title: "Sertifikasi Keamanan",
      description: "Memenuhi standar keamanan dan keselamatan nasional",
      color: "bg-indigo-500"
    }
  ];

  const applications = [
    {
      title: "CCTV & Sistem Pengawasan",
      description: "Pemasangan kamera pengawasan untuk keamanan properti dan area",
      image: "/image/layanan/cctv-tower.png",
      benefits: ["Jangkauan luas", "Stabilitas kamera", "Posisi strategis"]
    },
    {
      title: "Antena Internet & Jaringan",
      description: "Support untuk antena wireless, microwave, dan perangkat jaringan",
      image: "/image/layanan/internet-tower.png",
      benefits: ["Ketinggian optimal", "Reduced interference", "Coverage maksimal"]
    },
    {
      title: "Repeater Handy Talky",
      description: "Memperluas jangkauan komunikasi radio HT untuk area terpencil",
      image: "/image/layanan/ht-tower.png",
      benefits: ["Jangkauan extended", "Kualitas sinyal", "Komunikasi reliable"]
    },
    {
      title: "Sistem Telekomunikasi",
      description: "Support untuk berbagai perangkat telekomunikasi dan pemancar",
      image: "/image/layanan/telecom-tower.png",
      benefits: ["Multi-perangkat", "Scalability", "Future-proof"]
    }
  ];

  const installationProcess = [
    {
      step: "1",
      title: "Konsultasi & Assessment",
      description: "Analisis kebutuhan dan survei lokasi untuk menentukan solusi terbaik"
    },
    {
      step: "2",
      title: "Desain & Perencanaan",
      description: "Merancang tower sesuai dengan kebutuhan dan kondisi lokasi"
    },
    {
      step: "3",
      title: "Penyediaan Material",
      description: "Menyiapkan material berkualitas tinggi yang sesuai standar"
    },
    {
      step: "4",
      title: "Pondasi & Instalasi",
      description: "Pembangunan pondasi dan pemasangan tower oleh tim ahli"
    },
    {
      step: "5",
      title: "Pemasangan Perangkat",
      description: "Instalasi perangkat seperti CCTV, antena, atau repeater"
    },
    {
      step: "6",
      title: "Testing & Serah Terima",
      description: "Pengujian sistem dan pelatihan penggunaan untuk klien"
    }
  ];

  const towerSpecifications = [
    {
      height: "6 meter",
      material: "Baja Galvanis",
      capacity: "Hingga 50 kg",
      applications: "CCTV, Antena Kecil",
      windResistance: "Hingga 120 km/jam"
    },
    {
      height: "9 meter",
      material: "Baja Galvanis",
      capacity: "Hingga 80 kg",
      applications: "Multi CCTV, Antena Medium",
      windResistance: "Hingga 110 km/jam"
    },
    {
      height: "12 meter",
      material: "Baja Galvanis Heavy Duty",
      capacity: "Hingga 120 kg",
      applications: "CCTV Array, Multiple Antenna",
      windResistance: "Hingga 100 km/jam"
    },
    {
      height: "Custom",
      material: "Baja Galvanis Custom",
      capacity: "Disesuaikan Kebutuhan",
      applications: "Enterprise Solution",
      windResistance: "Disesuaikan Desain"
    }
  ];

  const packages = [
    {
      id: 1,
      name: "Paket Dasar",
      popular: false,
      color: "from-green-500 to-green-700",
      height: "6 meter",
      includes: [
        "Tower Triangle 6m",
        "Pondasi beton",
        "Installasi dasar",
        "Material galvanis",
        "Garansi 1 tahun"
      ]
    },
    {
      id: 2,
      name: "Paket Professional",
      popular: true,
      color: "from-green-500 to-green-700",
      height: "9 meter",
      includes: [
        "Tower Triangle 9m",
        "Pondasi reinforced",
        "Installasi profesional",
        "Material heavy duty",
        "Testing struktur",
        "Garansi 2 tahun",
        "Survey lokasi"
      ]
    },
    {
      id: 3,
      name: "Paket Enterprise",
      popular: false,
      color: "from-green-500 to-green-700",
      height: "Custom Tinggi",
      includes: [
        "Tower custom design",
        "Pondasi khusus",
        "Installasi lengkap",
        "Material premium",
        "Structural analysis",
        "Sertifikasi keamanan",
        "Maintenance package",
        "Garansi 3 tahun"
      ]
    }
  ];

  const testimonials = [
    {
      name: "Budi Santoso",
      role: "Facility Manager",
      company: "PT. Sentral Plaza",
      rating: 5,
      comment: "Tower triangle untuk CCTV kami sangat kokoh dan stabil, bahkan saat cuaca buruk.",
      avatar: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=60&h=60&fit=crop&crop=face"
    },
    {
      name: "Diana Sari",
      role: "Security Director",
      company: "RS. Sejahtera",
      rating: 5,
      comment: "Pemasangan tower untuk sistem pengawasan rumah sakit kami sangat profesional dan rapi.",
      avatar: "https://images.unsplash.com/photo-1494790108755-2616b612b786?w=60&h=60&fit=crop&crop=face"
    },
    {
      name: "Ahmad Rizki",
      role: "IT Manager",
      company: "Plantation Estate",
      rating: 5,
      comment: "Tower triangle memperluas jangkauan komunikasi HT kami di area perkebunan yang luas.",
      avatar: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=60&h=60&fit=crop&crop=face"
    }
  ];

  // Fungsi untuk mengarahkan ke WhatsApp dengan pesan otomatis
  const contactViaWhatsApp = (packageName = "Tower Triangle") => {
    const phoneNumber = "6287778882022"; // Ganti dengan nomor WhatsApp perusahaan
    const message = `Halo, saya tertarik dengan layanan ${packageName}. Bisakah saya mendapatkan informasi lebih lanjut?`;
    const encodedMessage = encodeURIComponent(message);
    window.open(`https://wa.me/${phoneNumber}?text=${encodedMessage}`, '_blank');
  };

  return (
    <div className={`min-h-screen transition-colors duration-300 ${
      isDarkMode ? 'bg-gray-900' : 'bg-[#dfe4e0ff]'
    }`}>
      
      {/* Navigation */}
      <Navbar />
      
      {/* Hero Section */}
      <section
        className={`py-20 px-4 relative overflow-hidden ${
          isDarkMode ? 'bg-gray-900' : ''
        }`}
        style={{
          backgroundColor: isDarkMode ? '#111827' : '#dfe4e0ff',
          backgroundImage: isDarkMode
            ? "linear-gradient(rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.7)), url('/image/tower-dark.jpg')"
            : "linear-gradient(rgba(255, 255, 255, 0.8), rgba(255, 255, 255, 0.8)), url('/image/tower-hero.jpg')",
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      >
        <div className="container mx-auto relative z-10">
          <div className="text-center mb-12">
            <div className={`inline-flex items-center gap-2 ${
              isDarkMode ? 'bg-green-900/30 text-green-400' : 'bg-green-100 text-[#1E9B4C]'
            } px-4 py-2 rounded-full text-sm font-medium mb-6`}>
              <Triangle className="w-4 h-4" />
              Tower Triangle Solutions
            </div>

            <h1
              className={`text-4xl md:text-6xl font-bold mb-6 ${
                isDarkMode ? 'text-white' : 'text-gray-900'
              }`}
            >
              Instalasi Tower Triangle
              <span className="block text-transparent bg-clip-text bg-gradient-to-r from-[#1E9B4C] to-green-700">
                Profesional & Berkualitas
              </span>
            </h1>

            <p
              className={`text-xl max-w-3xl mx-auto mb-8 ${
                isDarkMode ? 'text-gray-300' : 'text-gray-600'
              }`}
            >
              Penyediaan dan pemasangan menara segitiga (Tower Triangle) untuk mendukung instalasi 
              perangkat seperti CCTV, antena internet, dan repeater Handy Talky, guna memperluas 
              jangkauan komunikasi dan pengawasan.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <button 
                onClick={() => contactViaWhatsApp("Tower Triangle")}
                className="bg-[#1E9B4C] hover:bg-green-700 text-white font-semibold px-8 py-4 rounded-lg transition-colors duration-200 flex items-center justify-center gap-2"
              >
                <MessageCircle className="w-5 h-5" />
                Konsultasi Gratis
              </button>
            </div>
          </div>
        </div>
      </section>

      <div className="absolute inset-0">
        <img
          src="https://telnet.net.id/assets/bg.png"
          alt="Background pattern"
          className="w-full h-full object-cover opacity-20"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-transparent via-white/40 to-transparent dark:via-black/40"></div>
      </div>

      {/* Features Section */}
      <section className={`py-16 px-4 transition-colors duration-300 ${
        isDarkMode ? 'bg-gray-800' : 'bg-white'
      }`}>
        <div className="container mx-auto">
          <div className="text-center mb-12">
            <h2
              className={`text-3xl font-bold mb-4 ${
                isDarkMode ? 'text-white' : 'text-gray-900'
              }`}
            >
              Keunggulan Tower Triangle Kami
            </h2>
            <p
              className={`text-lg ${
                isDarkMode ? 'text-gray-300' : 'text-gray-600'
              }`}
            >
              Solusi terpercaya untuk kebutuhan menara komunikasi dan pengawasan
            </p>
            <div className="w-24 h-1 bg-gradient-to-r from-[#1E9B4C] to-green-600 mx-auto rounded-full mt-4"></div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {towerFeatures.map((feature, index) => (
              <div
                key={index}
                className={`
                  group p-6 rounded-xl shadow-lg overflow-hidden 
                  transform hover:scale-105 hover:shadow-2xl transition-all duration-300
                  ${isDarkMode 
                    ? 'bg-gray-800 border border-gray-700 hover:border-[#1E9B4C] shadow-gray-900/50' 
                    : 'bg-white border border-gray-100 hover:border-[#1E9B4C] shadow-gray-300/20'
                  }
                `}
              >
                <div
                  className={`w-16 h-16 rounded-lg flex items-center justify-center text-white mb-4
                    ${feature.color || 'bg-[#1E9B4C]'}
                  `}
                >
                  {feature.icon}
                </div>

                <h3
                  className={`text-xl font-bold mb-3 transition-colors ${
                    isDarkMode
                      ? 'text-white group-hover:text-[#1E9B4C]'
                      : 'text-gray-900 group-hover:text-[#1E9B4C]'
                  }`}
                >
                  {feature.title}
                </h3>

                <p
                  className={`transition-colors ${
                    isDarkMode 
                      ? 'text-gray-300 group-hover:text-gray-200' 
                      : 'text-gray-600 group-hover:text-gray-700'
                  }`}
                >
                  {feature.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Applications Section */}
      <section className={`py-16 px-4 transition-colors duration-300 ${
        isDarkMode ? 'bg-gray-900' : 'bg-gray-50'
      }`}>
        <div className="container mx-auto">
          <div className="text-center mb-12">
            <h2
              className={`text-3xl font-bold mb-4 ${
                isDarkMode ? 'text-white' : 'text-gray-900'
              }`}
            >
              Berbagai Aplikasi Tower Triangle
            </h2>
            <p
              className={`text-lg ${
                isDarkMode ? 'text-gray-300' : 'text-gray-600'
              }`}
            >
              Solusi serbaguna untuk berbagai kebutuhan komunikasi dan pengawasan
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {applications.map((application, index) => (
              <div
                key={index}
                className={`rounded-xl overflow-hidden shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105 ${
                  isDarkMode 
                    ? 'bg-gray-800 border border-gray-700 shadow-gray-900/50' 
                    : 'bg-white border border-gray-100 shadow-gray-300/20'
                }`}
              >
                <div className="relative">
                  <img
                    src={application.image}
                    alt={application.title}
                    className="w-full h-48 object-cover"
                  />
                  <div className={`absolute inset-0 ${
                    isDarkMode 
                      ? 'bg-gradient-to-t from-gray-800/20 to-transparent' 
                      : 'bg-gradient-to-t from-white/20 to-transparent'
                  }`}></div>
                </div>
                <div className="p-6">
                  <h3
                    className={`text-xl font-bold mb-3 ${
                      isDarkMode ? 'text-white' : 'text-gray-900'
                    }`}
                  >
                    {application.title}
                  </h3>
                  <p
                    className={`mb-4 ${
                      isDarkMode ? 'text-gray-300' : 'text-gray-600'
                    }`}
                  >
                    {application.description}
                  </p>
                  <div className="space-y-2">
                    {application.benefits.map((benefit, idx) => (
                      <div key={idx} className="flex items-center gap-2">
                        <CheckCircle className="w-4 h-4 text-[#1E9B4C] flex-shrink-0" />
                        <span className={`text-sm ${
                          isDarkMode ? 'text-gray-400' : 'text-gray-600'
                        }`}>
                          {benefit}
                        </span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Specifications Section */}
      <section className={`py-16 px-4 transition-colors duration-300 ${
        isDarkMode ? 'bg-gray-800' : 'bg-white'
      }`}>
        <div className="container mx-auto">
          <div className="text-center mb-12">
            <h2
              className={`text-3xl font-bold mb-4 ${
                isDarkMode ? 'text-white' : 'text-gray-900'
              }`}
            >
              Spesifikasi Teknis
            </h2>
            <p
              className={`text-lg ${
                isDarkMode ? 'text-gray-300' : 'text-gray-600'
              }`}
            >
              Pilihan tower sesuai dengan kebutuhan dan kondisi lingkungan
            </p>
          </div>

          <div className="overflow-x-auto">
            <table className={`w-full rounded-lg overflow-hidden ${isDarkMode ? 'bg-gray-700' : 'bg-gray-100'}`}>
              <thead>
                <tr className={isDarkMode ? 'bg-gray-600' : 'bg-gray-200'}>
                  <th className="p-4 text-left">Tinggi Tower</th>
                  <th className="p-4 text-left">Material</th>
                  <th className="p-4 text-left">Kapasitas Beban</th>
                  <th className="p-4 text-left">Aplikasi</th>
                  <th className="p-4 text-left">Ketahanan Angin</th>
                </tr>
              </thead>
              <tbody>
                {towerSpecifications.map((spec, index) => (
                  <tr key={index} className={isDarkMode ? 'border-gray-600' : 'border-gray-200'}>
                    <td className="p-4 font-medium">{spec.height}</td>
                    <td className="p-4">{spec.material}</td>
                    <td className="p-4">{spec.capacity}</td>
                    <td className="p-4">{spec.applications}</td>
                    <td className="p-4">{spec.windResistance}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </section>

      {/* Installation Process */}
      <section className={`py-16 px-4 transition-colors duration-300 ${
        isDarkMode ? 'bg-gray-900' : 'bg-gray-50'
      }`}>
        <div className="container mx-auto">
          <div className="text-center mb-12">
            <h2
              className={`text-3xl font-bold mb-4 ${
                isDarkMode ? 'text-white' : 'text-gray-900'
              }`}
            >
              Proses Instalasi
            </h2>
            <p
              className={`text-lg ${
                isDarkMode ? 'text-gray-300' : 'text-gray-600'
              }`}
            >
              Langkah-langkah profesional untuk hasil terbaik dan terjamin
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {installationProcess.map((step, index) => (
              <div
                key={index}
                className={`p-6 rounded-xl border-2 transition-all duration-300 hover:border-[#1E9B4C] hover:shadow-lg transform hover:scale-105 ${
                  isDarkMode 
                    ? 'bg-gray-800 border-gray-700 shadow-gray-900/50 hover:shadow-xl hover:bg-gray-750' 
                    : 'bg-gray-50 border-gray-200 shadow-gray-300/20 hover:shadow-xl hover:bg-white'
                }`}
              >
                <div className="flex items-center gap-4 mb-4">
                  <div className="w-12 h-12 rounded-full bg-[#1E9B4C] flex items-center justify-center text-white font-bold text-xl">
                    {step.step}
                  </div>
                  <h3 className={`font-bold text-lg ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>
                    {step.title}
                  </h3>
                </div>
                <p className={`${isDarkMode ? 'text-gray-300' : 'text-gray-600'}`}>
                  {step.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

     <Diskon />

      {/* CTA Section */}
      <section
        className={`py-16 px-4 transition-colors duration-300 ${
          isDarkMode ? 'bg-gray-900' : 'bg-[#1E9B4C]'
        }`}
      >
        <div className="container mx-auto text-center">
          <h2 className="text-3xl font-bold text-white mb-4">
            Siap Tingkatkan Jangkauan Anda?
          </h2>
          <p className="text-xl text-green-100 mb-8 max-w-2xl mx-auto">
            Dapatkan konsultasi gratis dari ahli kami untuk solusi Tower Triangle yang tepat untuk kebutuhan komunikasi dan pengawasan Anda.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button 
              onClick={() => contactViaWhatsApp("Tower Triangle")}
              className="bg-white text-[#1E9B4C] hover:bg-gray-100 font-semibold px-8 py-4 rounded-lg transition-colors duration-200 flex items-center gap-2 justify-center"
            >
              <MessageCircle className="w-5 h-5" />
              Konsultasi Gratis
            </button>
            <button 
              onClick={() => contactViaWhatsApp("Tower Enterprise")}
              className="border-2 border-white text-white hover:bg-white hover:text-[#1E9B4C] font-semibold px-8 py-4 rounded-lg transition-colors duration-200 flex items-center gap-2 justify-center"
            >
              <ArrowRight className="w-5 h-5" />
              Hubungi Sales
            </button>
          </div>
        </div>
      </section>
        
      {/* Footer */}
      <Footer />
    </div>
  );
};

export default TowerTrianglePage;